export enum EngagementType {
  Animation = 1 << 0,
  Render = 1 << 1,
  Interactive = 1 << 2,
  ThreeDPrint = 1 << 3,
}

export const EngagementTypeMetadata: {
  [key in EngagementType]: { description: string; cost: number; imageUrl: string };
} = {
  [EngagementType.Animation]: { description: 'Animation', cost: 2000, imageUrl: '/images/animation.jpg' },
  [EngagementType.Render]: { description: 'Render', cost: 500, imageUrl: '/images/render.jpg' },
  [EngagementType.Interactive]: { description: 'Interactive', cost: 5000, imageUrl: '/images/interactive.jpg' },
  [EngagementType.ThreeDPrint]: { description: '3D Print', cost: 3000, imageUrl: '/images/threedprint.jpg' },
};

export const EngagementTypeList = Object.entries(EngagementTypeMetadata).map(([key, value]) => ({
  engagementType: Number(key) as EngagementType,
  ...value,
}));
